import { useEffect } from 'react';

export default function useEventListener(element, event, listener) {
    useEffect(() => {
        element.addEventListener(event, listener);

        return () => {
            element.removeEventListener(event, listener);
        };
    });
}
